// extracted by mini-css-extract-plugin
export var component = "title-module--component--1DSoG";
export var strong = "title-module--strong--33NqP";
export var light = "title-module--light--15I6R";